import {
  getModule,
  Module,
  MutationAction,
  VuexModule
} from "vuex-module-decorators";
import store from "@/store";
import * as AccountAPI from "@/api/account";
import { isSuccess } from "@/api/response";
import { RegisterRequest } from "@/api/account/request";
import { RegisterResponse } from "@/api/account/response";

const MODULE_NAME = "account/register";

/**
 * 店舗アカウント登録更新APIのレスポンスを管理するストアモジュール
 */
@Module({ dynamic: true, store, name: MODULE_NAME, namespaced: true })
class Register extends VuexModule {
  // state
  registerResponse: RegisterResponse = {} as RegisterResponse;

  // getters
  get isSuccess() {
    return isSuccess(this.registerResponse);
  }

  get getMessage() {
    return this.registerResponse.message;
  }

  get getAccountId() {
    return this.registerResponse.results;
  }

  get getPreviewUrl() {
    if (this.registerResponse.results) {
      return this.registerResponse.previewResults.previewUrl;
    } else {
      return "";
    }
  }

  @MutationAction
  async register(registerRequest: RegisterRequest) {
    const registerResponse = await AccountAPI.register(registerRequest);
    return {
      registerResponse
    };
  }

  @MutationAction
  async clearResponse() {
    return {
      registerResponse: {} as RegisterResponse
    };
  }
}

export default getModule(Register);
